import './vendor/jquery.dotdotdot.js';
import './vendor/swiper.jquery.min.js';
import './vendor/jquery.putcursoratend.js';
import './vendor/lazyload.js';
import './bs/bootstrap.js';
import './modules/newsletter.js';
import './vendor/modernizr.js';
import './vendor/waypoints.js';
import './vendor/bootstrap-slider.js';
import 'bootstrap4-toggle';

import './account.js';
import './automerk.js';
import './checkout.js';
import './zipcode.js';
import './pdp.js';
import './sort.js';
import './cart.js';
import './lister.js';
import './mainmodels.js';
import './body.js';
import {maoInitMap, storeSelectedLocation} from './locator.js';
import $ from 'jquery';

window.maoInitMap = maoInitMap;
window.storeSelectedLocation = storeSelectedLocation;
$.fn.modal.Constructor.prototype.enforceFocus = function () {};

import.meta.glob(['/resources/assets/fonts/*']);

$('#carouselOnderdelen').slick({
    variableWidth: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    infinite: false,
    prevArrow: '<span class="arrow-carousel prev  fa fa-chevron-left"></span>',
    nextArrow: '<span class="arrow-carousel next  fa fa-chevron-right"></span>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
    ],
});
var lastScrollTop = 0;

$(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > 550) {
        // Adjust the value as needed
        $('.sticky_filter_bar').fadeIn(); // Show the sticky element
    } else {
        $('.sticky_filter_bar').fadeOut(); // Hide the sticky element
    }
    if (scrollPosition > 550 && scrollPosition < lastScrollTop) {
        // Adjust the value as needed
        $('.sticky_filter_bar_h').fadeIn(); // Show the sticky element
    } else {
        $('.sticky_filter_bar_h').fadeOut(); // Hide the sticky element
    }
    lastScrollTop = scrollPosition;
});

function scaleImageMap() {
    const img = document.getElementById('imgMap');
    const map = document.getElementById('compositionMap');

    if (!map) return;

    const areas = map.getElementsByTagName('area');

    if (!img.complete) {
        img.addEventListener('load', scaleImageMap);
        return;
    }

    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const displayWidth = img.clientWidth;
    const displayHeight = img.clientHeight;

    // Bereken schaalfactor
    const scaleX = displayWidth / naturalWidth;
    const scaleY = displayHeight / naturalHeight;

    // Sla originele coördinaten op (eerste keer)
    if (!map.dataset.coordsStored) {
        for (let area of areas) {
            area.dataset.originalCoords = area.coords;
        }
        map.dataset.coordsStored = 'true';
    }

    const highlight = document.getElementById('highlight');

    // Schaal alle area coördinaten
    for (let area of areas) {
        const originalCoords = area.dataset.originalCoords.split(',');
        const scaledCoords = originalCoords.map((coord, index) => {
            const scale = index % 2 === 0 ? scaleX : scaleY;
            return Math.round(parseFloat(coord) * scale);
        });
        area.coords = scaledCoords.join(',');
    }

    // Event listeners alleen toevoegen als ze nog niet bestaan
    if (!map.dataset.listenersAdded) {
        for (let area of areas) {
            area.addEventListener('mouseenter', () => {
                const [x1, y1, x2, y2] = area.coords.split(',').map(Number);

                highlight.style.left = x1 + "px";
                highlight.style.top = y1 + "px";
                highlight.style.width = (x2 - x1) + "px";
                highlight.style.height = (y2 - y1) + "px";
                highlight.style.display = 'block';
                highlight.style.position = 'absolute';
                highlight.style.border = '2px solid #f00';
                highlight.style.pointerEvents = 'none';

                $('tr.subPart[data-row-id="' + $(area).data('row-id') + '"]').addClass('bg-danger-hover');
            });

            area.addEventListener('mouseleave', () => {
                highlight.style.display = 'none';
                $('tr.subPart[data-row-id="' + $(area).data('row-id') + '"]').removeClass('bg-danger-hover');
            });
        }
        map.dataset.listenersAdded = 'true';
    }
}

$(function() {
    scaleImageMap();

    $('tr.subPart').mouseover(function () {
        const rowId = $(this).data('row-id');
        const area = document.querySelector('area[data-row-id="' + rowId + '"]');
        if (area) {
            const event = new Event('mouseenter');
            area.dispatchEvent(event);
        }
    });

    $('tr.subPart').mouseleave(function () {
        $(this).removeClass('bg-danger-hover');
        const area = document.querySelector('area[data-row-id="' + rowId + '"]');
        if (area) {
            const event = new Event('mouseleave');
            area.dispatchEvent(event);
        }
    });
})
